module.exports = __webpack_public_path__ + "img/kw.7c6bb071.jpg";